import React, { Fragment, useState, useEffect } from 'react';
import {
  ModalBody,
  ModalFooter,
  Modal,
  ModalHeader,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Spinner,
  Row,
  Label,
  Card,
  CardTitle,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { useDropzone } from 'react-dropzone';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Users_By_Id,
  gAPI_Twilio_Templates,
  gAPI_Twilio_Template_Content,
  Upload_Email_Attachment,
  gAPI_Conversations_Channel_Session,
} from '../../../../../constants/APIs';
import moment from 'moment';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import countryCodes from '../../../../../data/dial_code';

const TWILIOCHANNEL_URL = process.env.REACT_APP_CHAT_API + '/twiliochannels';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;       
      }

      .ql-container{
        border: 1px solid #ccc !important; 
        border-radius: 0px!important;   
        background:white;      
      }
      
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const NewWhatsAppConnection = ({
  visible,
  toggle,
  data,
  handleContactClick,
  whatsAppIntegration,
  propertyId,
  isLatestConversation,
  preFillPhoneNumber,
}) => {
  const [attachementList, setAttachmentList] = useState([]);
  const [conversationId, setConversationId] = useState();
  const fileObj = [];
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      // acceptedFiles.map((file) => {
      //   if (!file.name.includes('exe')) {
      //     fileObj.push({
      //       img: Object.assign(file, {
      //         preview: URL.createObjectURL(file),
      //       }),
      //     });
      //   }
      // });
      // setAttachmentList([...attachementList, ...fileObj]);
    },
  });
  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
  const [emailData, setEmailData] = useState({
    from: whatsAppIntegration?.channelDetails?.forwardingEmail,
    templateId: '',
    to: '',
    countryCode: '+64',
    rawNumber: preFillPhoneNumber || '',
    text: '',
    attachments: [],
  });

  const handleChange = (e) =>
    setEmailData({ ...emailData, [e.target.name]: e.target.value });

  const handleMessage = (source, e) => {
    if (source === 'user') setEmailData({ ...emailData, text: e });
  };

  const handleRemove = (index) => {
    let lst = [...attachementList];
    lst = lst.filter((f, i) => i !== index);
    setAttachmentList(lst);
    // handleFiles(lst);
  };
  useEffect(() => {
    if (statusMessage.text) {
      const timer = setTimeout(() => {
        setStatusMessage({ text: '', type: '' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  useEffect(() => {
    if (propertyId !== '-1') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
      }).then((res) => {
        const filtered = (res.data || []).filter((t) =>
          t.channel?.includes('WhatsApp')
        );
        setTemplateList(filtered);
        if (preFillPhoneNumber !== undefined && preFillPhoneNumber != null) {
          countryCodes.map((m) => {
            if (preFillPhoneNumber.startsWith(m.dial_code)) {
              preFillPhoneNumber = preFillPhoneNumber.replace(m.dial_code, '');
              setEmailData({
                ...emailData,
                rawNumber: preFillPhoneNumber,
                countryCode: m.dial_code,
              });
            }
          });
        }
      });
    }
  }, [propertyId, preFillPhoneNumber]);

  const handleTemplate = (e) => {
    let templateData = templateList.filter(
      (f) => f.templateId === e.target.value
    );
    if (templateData.length > 0) {
      setLoading(true);
      AxiosPublicAPI({
        method: 'post',
        url:
          process.env.REACT_APP_CHAT_API +
          '/twilio-template-content' +
          '/' +
          templateData[0].templateId +
          '?item=' +
          templateData[0].templateType,
        data: {
          accountSID: whatsAppIntegration?.channelDetails?.accountSID,
          authToken: whatsAppIntegration?.channelDetails?.authToken,
        },
      }).then((res) => {
        // console.log(res.data);
        let text = '';
        if (res.data?.title && res.data?.title != null) {
          text += res.data?.title + '\n';
        }
        if (res.data?.subTitle && res.data?.subTitle != null) {
          text += res.data?.subTitle + '\n';
        }
        if (res.data?.body && res.data?.body != null) {
          text += res.data?.body + '\n';
        }
        let placeholders = [];
        if (text.length > 0) {
          var regex = new RegExp(/{{(.*?)}}/, 'g');
          const regexNEw = /{{(.*?)}}/;
          var match = regexNEw.exec(text).groups;
          //console.log(match, 164);
          Array.from(text.matchAll(regex), (m) => m[0]).map((m) =>
            placeholders.push({ key: m, value: '' })
          );
        }
        setEmailData({
          ...emailData,
          text: text,
          templateId: e.target.value,
          placeholders: placeholders,
        });
        setLoading(false);
      });
    }
  };

  const handlePlaceHolders = (value, index) => {
    let placeholders = [...emailData.placeholders];
    placeholders[index].value = value;
    //console.log(placeholders);
    setEmailData({ ...emailData, placeholders: placeholders });
    //console.log(whatsAppIntegration);
  };

  const sendMessage = async (draft = false) => {
    let templateData = {};
    let placeholders = [...emailData.placeholders];
    if (placeholders.filter((f) => f.value === '').length === 0) {
      placeholders.map(
        (m) =>
          (templateData[m.key.replaceAll('{', '').replaceAll('}', '')] =
            m.value)
      );
      let message = emailData.text;
      placeholders.map((m) => (message = message.replace(m.key, m.value)));
      let requestBody = {
        groupId: getGroupID(),
        integrationId: whatsAppIntegration?.id,
        UsingLocalStorage: true,
        welcomeMessage: 'https://whatsapp.com',
        language: 'en-US',
        message: message,
        fromNumber: `whatsapp:${whatsAppIntegration?.channelDetails?.phoneNumber.trim(
          ' '
        )}`,
        propertyId: propertyId,
        toNumber: `${emailData.to.trim(' ')}`,
        templateId: emailData?.templateId,
        templateData: templateData,
        accountSID: whatsAppIntegration?.channelDetails?.accountSID,
        authToken: whatsAppIntegration?.channelDetails?.authToken,
        messageService: whatsAppIntegration?.channelDetails?.messageService,
      };
      //console.log('req', requestBody);
      let url = `${process.env.REACT_APP_CHAT_API}/proactiveMessage`;
      AxiosPublicAPI({
        method: 'post',
        url: url,
        data: requestBody,
      }).then((res) => {
        setStatusMessage({ text: 'success_msg', type: 'success' });
        toggle();
      });
    } else {
      setStatusMessage({ text: 'failed_msg', type: 'error' });
      NotificationManager.error(
        '',
        <IntlMessages id="dashboard.error_msg" />,
        3000,
        null,
        null,
        'error'
      );
    }
  };

  const changeConversation = () => {
    if (data !== undefined && data.length > 0) {
      data.map((m, index) => {
        if (m.conversationId === conversationId) {
          //console.log(m, 'm');
          handleContactClick(index, conversationId);
        }
      });
    }
  };

  const checkCurrentSession = (e) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Conversations_Channel_Session}?integration_id=${
        whatsAppIntegration?.id
      }&group_id=${getGroupID()}&from_number=${
        emailData?.to
      }&to_number=whatsapp:${whatsAppIntegration?.channelDetails?.phoneNumber.trim(
        ' '
      )}`,
    }).then((res) => {
      if (res.data.from !== null && res.data.to !== null) {
        //console.log(res.data.isLatestConversation === true,'res.data.isLatestConversation === true')
        if (res.data.isLatestConversation === true)
          setConversationId(res.data.conversationId);
      } else sendMessage();
    });
  };

  const handleAttachmentUpload = async (sessionId) => {
    const data = new FormData();
    attachementList.forEach((file) => {
      data.append('files', file.img);
    });
    data.append('sessionId', sessionId);
    data.append('creator', 'dashboard');
    return await AxiosAPI({
      method: 'post',
      url: `${Upload_Email_Attachment}`,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
  const isUSNumber = emailData?.countryCode === '+1';
  //console.log(297);
  return (
    <Fragment>
      <Card className="cardHeightActive mt-2 ">
        <CardTitle className="ml-3">
          <IntlMessages id="content.sendwhatsapp" />{' '}
        </CardTitle>

        <style>{styles}</style>
        <Row className="ml-2 mr-2">
          <Colxx md="12" className="mb-2">
            <Label>
              <IntlMessages id="guest-messaging.templates" />
            </Label>
            <Input
              type="select"
              //value={}
              name="Template"
              onChange={handleTemplate}
            >
              <option value="">
                <IntlMessages id="content.please_select" />
              </option>
              {templateList &&
                templateList.length > 0 &&
                templateList.map((m) => (
                  <option value={m?.templateId}>{m?.name}</option>
                ))}
            </Input>
          </Colxx>
          {emailData?.templateId && emailData?.templateId !== '' ? (
            <Fragment>
              {loading ? (
                <div className="text-center" style={{ position: 'fixed' }}>
                  <div className="loading" />
                </div>
              ) : (
                <Fragment>
                  <Colxx md="12" className="mb-2">
                    <Label>
                      <IntlMessages id="property.message" />
                    </Label>
                    <Input
                      type="textarea"
                      value={emailData?.text}
                      name="conditions"
                      disabled={true}
                      // onChange={handleChangeConditionsArr}
                    />
                  </Colxx>

                  {emailData?.placeholders &&
                    emailData?.placeholders.map((e, index) => (
                      <Colxx md="6" className="mb-2">
                        <Label>
                          <IntlMessages id="content.add_placeholder" />
                        </Label>
                        <InputGroup>
                          <InputGroupAddon>
                            <InputGroupText>{e?.key}</InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            name={e?.key}
                            id={e?.key}
                            value={e?.value}
                            onChange={(v) =>
                              handlePlaceHolders(v.target.value, index)
                            }
                          />
                        </InputGroup>
                      </Colxx>
                    ))}

                  <Colxx md="12" className="mb-2">
                    <Label>
                      <IntlMessages id="content.mobile_number" />
                    </Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <Input
                          type="select"
                          name="countryCode"
                          value={emailData.countryCode || '+64'}
                          onChange={(e) =>
                            setEmailData({
                              ...emailData,
                              countryCode: e.target.value,
                              to: `${e.target.value}${
                                emailData.rawNumber || ''
                              }`,
                            })
                          }
                          style={{
                            width: '100px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          {countryCodes.map((c) => (
                            <option key={c.code} value={c.dial_code}>
                              {c.code} {c.dial_code} ({c.name})
                            </option>
                          ))}
                        </Input>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        // placeholder="Enter phone number"
                        value={emailData.rawNumber || ''}
                        disabled={isUSNumber}
                        style={{
                          backgroundColor: isUSNumber ? '#e9ecef' : 'white',
                          cursor: isUSNumber ? 'not-allowed' : 'text',
                        }}
                        onChange={(e) => {
                          if (isUSNumber) return;
                          const number = e.target.value.replace(/\D/g, '');
                          setEmailData({
                            ...emailData,
                            rawNumber: number,
                            to: `${emailData.countryCode || '+64'}${number}`,
                          });
                        }}
                      />
                    </InputGroup>
                    {isUSNumber && (
                      <div
                        style={{
                          color: 'black',
                          fontSize: '12px',
                          marginTop: '5px',
                        }}
                      >
                        <b>
                          {' '}
                          <IntlMessages id="dashboard.us_number" />
                        </b>
                      </div>
                    )}
                  </Colxx>
                  {conversationId !== undefined && (
                    <Colxx
                      md="12"
                      className="mb-2"
                      style={{ marginTop: '0.5rem', color: 'green' }}
                    >
                      <IntlMessages id="dashboard.user_msg" />{' '}
                      <button
                        style={{ textDecoration: 'underline' }}
                        onClick={changeConversation}
                      >
                        View
                      </button>
                    </Colxx>
                  )}
                  {/* <Colxx md="12" className="mb-2">
                      {attachementList.map((file, index) => (
                        <Row className="mx-0">
                          <Colxx
                            md="10"
                            style={{ border: '1px solid', padding: '5px 10px' }}
                          >
                            <div key={index}>
                              <div className="row mx-0">
                                <span data-dz-name>{file.img.name}</span>
                                <div
                                  className="text-primary text-extra-small"
                                  data-dz-size
                                >
                                  {file.img.size}
                                </div>
                              </div>
                            </div>
                          </Colxx>
                          <Colxx md="2">
                            <Button
                              color="danger"
                              outline
                              size="xs"
                              onClick={() => handleRemove(index)}
                            >
                              X
                            </Button>
                          </Colxx>
                        </Row>
                      ))}
                    </Colxx> */}
                </Fragment>
              )}
            </Fragment>
          ) : null}
        </Row>
        <div className="text-left ml-4 mt-4 mb-4">
          {statusMessage.text && (
            <div
              className="mb-2 font-medium"
              style={{
                color: statusMessage.type === 'success' ? 'green' : 'red',
              }}
            >
              <b>
                {statusMessage?.text === 'success_msg' ? (
                  <IntlMessages id="dashboard.message_sent" />
                ) : (
                  <IntlMessages id="dashboard.failed_msg" />
                )}
              </b>
            </div>
          )}
          {emailData?.templateId && emailData?.templateId !== '' ? (
            <Button
              color="primary"
              size="xs"
              onClick={checkCurrentSession}
              disabled={isUSNumber}
            >
              <IntlMessages id="dashboards.send" />
            </Button>
          ) : null}
          {/* <Button className='ml-2' color="secondary" size="xs" onClick={toggle}>
            Cancel
          </Button> */}
        </div>
      </Card>
    </Fragment>
  );
};

export default NewWhatsAppConnection;
